<template>
  <div class="input__wrapper">
    <div :class="['input', inputState]" @click="start">
      <div :class="['input__picture', inputState]">
        <img src="@/assets/img/new-search.svg" alt="phone" />
      </div>
      <div :class="['input__content', inputState]">
        <div :class="['input__content-prompt', inputState]">
          {{ title }}
        </div>
        <input
          ref="input"
          v-model="inputContent"
          :class="['input__content-input', inputState]"
          @input="inputChanged"
          @blur="inputDone"
        />
      </div>
    </div>
    <el-collapse-transition>
      <div v-if="showSearchList" class="input__search">
        <el-table
          v-if="loading"
          v-loading="loading"
          :data="[1]"
        />
        <template v-else>
          <div
            v-for="(item, index) in searchList"
            :key="index"
            class="input__search-item"
            @click="selectByList(item)"
            v-html="highlightSearch(item)"
           />
        </template>
      </div>
    </el-collapse-transition>
    <el-collapse-transition>
      <div v-if="showError" class="input__error">
        <div class="input__error-image">
          <img src="@/assets/img/new-error.svg" alt="phone">
        </div>
        <p class="input__error-text">Ошибка запроса</p>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { DOUBLE_SEARCH_CLASSES, DOUBLE_SEARCH_STATUSES } from './constants'
import { mapGetters } from 'vuex'

export default {
  name: 'DoubleInputSearch',
  props: {
    title: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    showSearchList: {
      type: Boolean,
      default: false,
    },
    searchList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputContent: '',
      inputStatus: DOUBLE_SEARCH_STATUSES.init,
    }
  },
  computed: {
    inputState() {
      if (this.inputStatus === DOUBLE_SEARCH_STATUSES.done) {
        return (this.hasError)
          ? DOUBLE_SEARCH_CLASSES[DOUBLE_SEARCH_STATUSES.error]
          : DOUBLE_SEARCH_CLASSES[DOUBLE_SEARCH_STATUSES.done]
      }

      return DOUBLE_SEARCH_CLASSES[this.inputStatus]
    },
    showError() {
      return this.hasError && this.inputStatus !== DOUBLE_SEARCH_STATUSES.edit
    },
  },
  methods: {
    // подсветка совпадающего с шаблоном поиска куска строки
    highlightSearch(item) {
      let index = item.indexOf(this.inputContent)
      let first = item.slice(0, index)
      let last = item.slice(index + this.inputContent.length)

      return `${first}<span style="color: #27A359">${this.inputContent}</span>${last}`
    },
    // нажали на инпут поиска
    start() {
      this.inputStatus = DOUBLE_SEARCH_STATUSES.edit
      this.$refs.input.focus()
    },
    // изменилось содержимое поля ввода
    inputChanged() {
      this.$emit('input-changed', this.inputContent)
    },
    // ушли с поля ввода
    inputDone() {
      this.inputStatus = (this.inputContent.length)
        ? DOUBLE_SEARCH_STATUSES.done
        : DOUBLE_SEARCH_STATUSES.init
      this.$emit('input-blured', this.inputContent)
    },
    // выбран элемент в выпадающем списке
    selectByList(item) {
      this.inputStatus = DOUBLE_SEARCH_STATUSES.done
      this.inputContent = item
      this.$emit('input-selected', this.inputContent)
    },
  },
}
</script>

<style lang="sass" scoped>
.input__wrapper
  position: relative
.input
  display: flex
  width: 100%
  height: 5rem
  margin-bottom: 0.2rem
  border-radius: 0.8rem
  background: #F8F8F8
  cursor: pointer

  &.edit
    border: 1px solid #FF7F37
  &.error
    border: 1px solid #FF3030

  &__picture
    display: flex
    justify-content: center
    align-items: center
    width: 5.6rem
    background: #EDEDED
    border-radius: 8px 0 0 8px
    &.error
      background: #FFC0C0
    img
      width: 1.6rem
      height: 1.6rem

  &__content
    flex: 1
    display: flex
    flex-direction: column
    justify-content: center
    padding: 0.6rem 1.2rem
    border-radius: .8rem
    &.error
      background: #FFF2F2

    &-input
      height: 0
      padding: 0
      border-width: 0
      outline: none
      font-size: 0
      background: #F8F8F8
      transition: height .3s ease
      &.edit, &.done, &.error
        height: 2.4rem
        font-size: 1.6rem
        color: #181818
      &.error
        background: #FFF2F2

    &-prompt
      font-size: 1.6rem
      color: #5C5C5C
      transition: all .3s ease
      &.edit, &.done, &.error
        margin-bottom: .4rem
        font-size: 1.2rem
        font-weight: 700
        line-height: 1.6rem
        color: #5C5C5C

.input__search
  position: absolute
  top: calc(100% + .8rem)
  width: 100%
  height: fit-content
  max-height: 19.2rem
  background: #FFFFFF
  box-shadow: 0 0 1rem rgba(132, 132, 132, 0.15)
  border-radius: .4rem
  overflow: scroll
  z-index: 100

  &-item
    display: flex
    align-items: center
    height: 4.8rem
    padding-left: 1.6rem
    font-size: 1.6rem
    font-weight: 400
    span
      color: $mainColor

.input__error
  display: flex
  align-items: center

  &-image
    width: 1.6rem
    height: 1.6rem
    margin-right: 0.9rem

    img
      width: 100%
      height: 100%
  &-text
    font-size: 1.2rem
    color: #FF3030
</style>
